import { Project } from "@/interfaces/project.interface";
import { ApiQueryParams, apiRequest } from "../Api";
import { buildFilterParams, type FilterParam } from "@/hooks/apis/utils";

export interface Filter {
  field: string;
  value: string;
}

export interface GetProjectListRequest extends ApiQueryParams {
  page?: number;
  page_limit?: number;
  search?: string;
  sort_by?: string;
  filters?: FilterParam[];
}

export interface GetProjectListResponse {
  success: boolean;
  message: string;
  data: Project[];
  cached: boolean;
  total: number;
  page_items: number;
  last_page: number;
  current_page: number;
}

export const listProjects = (params: GetProjectListRequest) => {
  const { filters, ...restParams } = params;
  const filterParams = buildFilterParams(filters);

  return apiRequest<void, GetProjectListResponse>({
    url: '/entities/list',
    scope: 'project',
    method: 'GET',
    params: { ...restParams, ...filterParams },
  });
};